import React from 'react'
import getDateStringFromCustomDate from '../../../../../util/getDateStringFromCustomDate'
import { CustomDateObject } from '../../../../../shared/types'

export enum DateAndPlaceType {
  birth = 'birth',
  death = 'death',
}

interface IDateAndPlaceProps {
  date?: CustomDateObject
  place?: string
  type?: DateAndPlaceType
}

const DateAndPlace: React.FC<IDateAndPlaceProps> = ({ date, place, type }) => {
  return (
    <>
      {date && getDateStringFromCustomDate(date) && place &&
        <>{`${type ? (type === DateAndPlaceType.birth ? 'geb. ' : 'gest. ') : ''} ${getDateStringFromCustomDate(date)} ${place && `in ${place}`}`}</>}
      {!date && place &&
        <>{`${type ? (type === DateAndPlaceType.birth ? 'geb. in' : 'gest. in') : ''} ${place}`}</>}
      {date && getDateStringFromCustomDate(date) && !place &&
        <>{`${type ? (type === DateAndPlaceType.birth ? 'geb. ' : 'gest. ') : ''} ${getDateStringFromCustomDate(date)}`}</>}
    </>
  )
}

export default DateAndPlace
